// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"Plantilla_layoutWrapper__RcNpv","mainContent":"Plantilla_mainContent__XF7Fp"};